export enum CardFinish {
	ETCHED = "etched",
	FOIL = "foil",
	GLOSSY = "glossy",
	NONFOIL = "nonfoil",
	// SIGNED = "signed",
}
